
import React from 'react';
import { motion } from 'framer-motion';

const images = [
  { id: 1, src: "/images/gallery/11.jpg", alt: "", desc: "" },
  { id: 2, src: "/images/gallery/12.jpg", alt: "", desc: "" },
  { id: 3, src: "/images/gallery/13.jpg", alt: "", desc: "" },
  { id: 4, src: "/images/gallery/14.jpg", alt: "", desc: "" },
  { id: 5, src: "/images/gallery/15.jpg", alt: "", desc: "" },
  { id: 6, src: "/images/gallery/16.jpg", alt: "", desc: "" },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.8, y: 50 },
  visible: { 
    opacity: 1, 
    scale: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 100 } 
  },
};

const Gallery = () => {
    return (
        <section className="bg-card py-20 sm:py-32">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl md:text-5xl font-black text-foreground">GALERI PETUALANGAN</h2>
                    <p className="mt-4 max-w-3xl mx-auto text-lg text-muted-foreground">
                        Lihat kembali momen-momen tak terlupakan dari para pejuang yang menaklukkan alam liar Banyumas.
                    </p>
                </motion.div>
                
                <motion.div 
                    className="grid grid-cols-2 md:grid-cols-3 gap-4"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                >
                    {images.map((image, index) => (
                        <motion.div
                            key={image.id}
                            className="relative overflow-hidden rounded-lg shadow-lg group"
                            variants={itemVariants}
                        >
                            <img className="w-full h-full object-cover transform transition-transform duration-500 ease-in-out group-hover:scale-110"
                                alt={image.alt}
                                src={image.src}
                                />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                            <div className="absolute bottom-0 left-0 p-4">
                                <p className="text-white font-semibold text-sm md:text-base">{image.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Gallery;
